import React from 'react';
import { DashboardStats } from '../../types';

interface RecentActivityProps {
  stats: DashboardStats;
}

const RecentActivity: React.FC<RecentActivityProps> = ({ stats }) => {
  const approvalRate = stats.total > 0 ? Math.round((stats.approved / stats.total) * 100) : 0;

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">
          <span>📈</span>
          Recent Activity
        </h3>
        <p className="card-description">Latest beta signup statistics and trends</p>
      </div>
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <span>Total Applications</span>
          <strong>{stats.total}</strong>
        </div>
        <div className="flex justify-between items-center">
          <span>Approval Rate</span>
          <strong>{approvalRate}%</strong>
        </div>
        <div className="flex justify-between items-center">
          <span>Pending Review</span>
          <strong>{stats.pending}</strong>
        </div>
      </div>
    </div>
  );
};

export default RecentActivity;
